//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Steward',
  data () {
    return {
      form: {
        wakefulness: '',
        breath: '',
        physical: '',
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '2', name: '完全清醒'},
        {value: '1', name: '对刺激有反应'},
        {value: '0', name: '对刺激无反应'}
      ],
      dataList2: [
        {value: '2', name: '可按医师吩咐咳嗽'},
        {value: '1', name: '可自主维持呼吸道通畅'},
        {value: '0', name: '需予以呼吸道支持'}
      ],
      dataList3: [
        {value: '2', name: '肢体可做有意识的运动'},
        {value: '1', name: '肢体无意识运动'},
        {value: '0', name: '肢体无运动'}
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/Steward.vue